import styled from 'styled-components'
import { colors, updatedMedia } from 'client/styles'
import { InputGroup, Label } from 'client/components/InputReadOnly/styles'

export const DateSelectorBase = styled.div`
  width: 100%;
`

export const Content = styled.div`
  align-items: center;
  background-color: ${colors.white};
  border-radius: 8px;
  border: 2px solid;
  border-color: ${props => (props.isFocus ? colors.grey1 : colors.grey4)};
  display: flex;
  justify-content: space-between;
  position: relative;
  height: 100%;

  ${updatedMedia.desktop} {
    &:hover {
      border-color: ${colors.grey1};
    }
  }

  ${props =>
    props.type === 'inline' &&
    `
      flex: 0 0 auto;
      margin-inline-end: .75em;
      width: 300px;
      padding-block: 0;
      padding-inline: 1rem;
  `};

  .datepicker-default {
    position: absolute;
    inset-block-start: calc(100% + 10px);
    inset-inline-start: 0;
    z-index: var(--z-low);
  }

  ${InputGroup}:first-of-type {
    border-inline-end: 2px solid ${colors.grey4};
  }
  ${Label} {
    background-color: transparent;
    padding-block: 6px;
    padding-inline: 12px;
  }
`
